import { APP_NAME } from 'config';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { firebase as fb, helpers } from 'redux-firebasev3';
import { Link } from 'react-router';
import last from 'lodash/last';

import logoGrayImage from '../..//images/logoGray.svg';
import userPlaceholderImage from '../../images/userPlaceholder.svg';

import blackTriangleImage from './blackTriangle.svg';
import S from './style.css';

const { isLoaded, pathToJS } = helpers;

@fb()
@connect(
  ({ firebase }) => ({
    auth: pathToJS(firebase, 'auth'),
    profile: pathToJS(firebase, 'profile'),
  })
)
class App extends Component {
  static propTypes = {
    auth: PropTypes.object,
    children: PropTypes.node,
    content: PropTypes.node,
    firebase: PropTypes.object,
    header: PropTypes.node,
    profile: PropTypes.object,
    routes: PropTypes.array.isRequired,
  }

  state = {
    isMenuOpen: false,
  }

  componentDidUpdate() {
    const { auth, profile } = this.props;
    if (!this.hasIdentifiedForAnalytics && profile && auth) {
      this.hasIdentifiedForAnalytics = true;
      const userProps = {
        lastStatusAt: profile.lastStatusAt,
        teamId: profile.teamId,
        username: profile.username,
      };

      if (heap) {
        heap.identify(auth.uid);
        heap.addUserProperties(userProps);
      }

      if (Raven) {
        Raven.setUserContext({ ...userProps, id: auth.uid });
      }
    }
  }

  hasIdentifiedForAnalytics = false;

  handleMenuClick = () => {
    this.setState({
      isMenuOpen: !this.state.isMenuOpen
    });
  }

  handleSignOutClick = () => {
    this.props.firebase.logout().then(() => {
      window.location.pathname = '/';
    })
    .catch((error) => {
      if (Raven) {
        Raven.captureMessage('Sign out error', {
          extra: { error }
        });
      }
      alert('Error signing you out. Try clearing your browser history.'); // eslint-disable-line no-alert, max-len
    });
  }

  render() {
    const {
      children,
      content,
      header,
      profile,
      routes,
    } = this.props;
    const { isMenuOpen } = this.state;

    const isLoggedIn = isLoaded(profile) && profile;

    const footerJSX = (
      <div className="tc mt5 pb2">
        <a
          className="no-underline"
          href="https://www.postlight.com"
          rel="noopener noreferrer"
          style={{ color: '#a7b6c5' }}
          target="_blank"
        >
          <div className="dt center">
            <div className="dtc v-mid">
              <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" height="46" width="204" viewBox="0 0 73 13"><defs><clipPath id="clip-path" transform="translate(0 -.66)"><path fill="none" d="M0 .66h72.75v12.65H0z"/></clipPath><style/></defs><path fill="#FFF" d="M43.98 0l-1.75 1.69v7.82h1.82V0h-.07z"/><path fill="#FFF" d="M46.59 3a1.1 1.1 0 01-.79-.32 1.12 1.12 0 01-.32-.79 1.15 1.15 0 01.32-.79 1.11 1.11 0 01.79-.33 1.13 1.13 0 011.13 1.12A1.13 1.13 0 0146.59 3M39.35 5.06h-3.1V3.29h1.2v-1.9h1.9v1.9h1.58v1.77h-1.58v2.78a.84.84 0 00.17.59.94.94 0 00.54.2h.87v1.67a4 4 0 01-2.68-.39 2.32 2.32 0 01-.79-2v-1zM28.16 9.28a3.8 3.8 0 01-5.29 0 3.63 3.63 0 01-1.07-2.64 3.73 3.73 0 013.74-3.72A3.77 3.77 0 0128.16 4a3.56 3.56 0 011.09 2.63 3.6 3.6 0 01-1.08 2.64m-4-1.27a1.92 1.92 0 003.28-1.39 1.88 1.88 0 00-.55-1.4 2 2 0 00-2.73 0 1.91 1.91 0 00-.53 1.4A1.9 1.9 0 0024.17 8M32 5.18c0 .19.12.34.37.47a6.92 6.92 0 00.91.3 8.3 8.3 0 011.07.34 2 2 0 01.9.68 1.82 1.82 0 01.38 1.19 2 2 0 01-.81 1.68 3.37 3.37 0 01-2 .51 2.93 2.93 0 01-3-1.61l1.57-.89a1.32 1.32 0 001.38.92c.65 0 1-.2 1-.61 0-.18-.12-.33-.38-.45a4.2 4.2 0 00-.9-.32A10.28 10.28 0 0131.45 7a2.3 2.3 0 01-.91-.66 1.87 1.87 0 01-.37-1.16 2 2 0 01.76-1.63A3.07 3.07 0 0132.85 3a3.17 3.17 0 011.56.39 2.7 2.7 0 011.11 1.11L34 5.33a1.14 1.14 0 00-1.12-.72 1 1 0 00-.59.16.48.48 0 00-.23.42M56.35 3.2h-1.77V4a2.62 2.62 0 00-2.25-1 3.29 3.29 0 00-2.49 1 3.56 3.56 0 00-1 2.55 3.6 3.6 0 001 2.56 3.41 3.41 0 002.53 1 2.64 2.64 0 002.23-1v.76a1.67 1.67 0 01-.49 1.28 2.39 2.39 0 01-3.22-.53l-1.49.93a3 3 0 001.29 1.23 4.46 4.46 0 002 .44 4 4 0 002.56-.89 3 3 0 001.1-2.48zm-3.74 5.29A2 2 0 0151.19 8a1.86 1.86 0 01-.55-1.39 1.8 1.8 0 01.55-1.37 2 2 0 011.42-.55 2 2 0 011.39.5 1.8 1.8 0 01.56 1.37A1.87 1.87 0 0154 8a2 2 0 01-1.41.54M61.91 3a2.48 2.48 0 011.9.77 2.9 2.9 0 01.76 2.14v4.32h-1.82V6.12a1.39 1.39 0 00-.38-1.07 1.34 1.34 0 00-1-.38 1.46 1.46 0 00-1.12.44 1.61 1.61 0 00-.37 1.25v3.81H58V1.39h1.85v2.55a2.22 2.22 0 012-1" transform="translate(0 -.66)"/><path fill="#FFF" d="M71.53.62v.21h-.3v.87h-.21V.83h-.3V.62h.81zM72.75 1.7V.62h-.23l-.31.51-.32-.51h-.22V1.7h.22V1l.3.5h.03l.31-.5v.7h.22zM45.67 3.01h1.86v6.5h-1.86z"/><path fill="#FFF" d="M20.47 1.88a3.27 3.27 0 00-2.39-1H14v9.29h2v-2.6h2.14a3.31 3.31 0 002.38-1 3.19 3.19 0 001-2.36 3.13 3.13 0 00-1-2.34M19.1 5.3a1.34 1.34 0 01-1 .41H16v-3h2.13a1.34 1.34 0 011 .42 1.42 1.42 0 01.38 1.06 1.54 1.54 0 01-.38 1.08M68.6 5.06h1.58V3.29H68.6v-1.9h-1.85v1.9h-1.21v1.77h1.21v2.88a2.28 2.28 0 00.79 2 4 4 0 002.64.35v-1.7h-.87a.94.94 0 01-.54-.2.84.84 0 01-.17-.59z" transform="translate(0 -.66)"/><path fill="#ff002e" d="M0 0h9.69L0 9.49V0z"/></svg>
            </div>
            <div className="dtc v-mid pl1">
              SOTU is a Labs product from your friends at  Postlight
            </div>
          </div>
        </a>
      </div>
    );

    if (last(routes).noHeader) {
      return (
        <div>
          <div className={S.content}>
            { children || content }
          </div>
          { !last(routes).noFooter && footerJSX }
        </div>
      );
    }

    const imageOrPlaceholder = profile && profile.image ?
      profile.image
      :
      userPlaceholderImage;

    const wrapClasses = 'mw9-ns ph3 ph4-ns center';

    return (
      <div>
        <div className={S.content}>
          <header className="pv3-ns mb4 pv1 navy app-bg-light-blue app-shadow-1">
            <div className={`${wrapClasses} dt dt--fixed`}>
              <div className="dtc v-mid w-25-ns w3">
                { header }
              </div>
              <div className="dtc v-mid w-50-ns w-80">
                <Link to="/dashboard">
                  <img
                    alt={APP_NAME}
                    className="db center pb1"
                    height="25px"
                    src={logoGrayImage}
                    width="95px"
                  />
                </Link>
              </div>
              <div className="dtc v-mid w-25-ns w3">
                {isLoggedIn &&
                  <div className="relative fr">
                    <div>
                      <button
                        className="pa0 m0 bn bg-transparent outline-0 cursor-pointer dt"
                        onClick={this.handleMenuClick}
                        type="submit"
                      >
                        <div className="dtc v-mid">
                          <img
                            alt="Profile"
                            className="br2"
                            height="30px"
                            src={imageOrPlaceholder}
                            title={profile.name || profile.username}
                            width="30px"
                          />
                        </div>
                        <div className="dtc v-mid pl2">
                          <img alt="Menu arrow" src={blackTriangleImage} />
                        </div>
                      </button>
                    </div>
                    {isMenuOpen &&
                      <ul
                        className="absolute bg-white pv1 ph2 list br2 shadow-3 tl app-f7"
                        style={{
                          bottom: '-4.5rem',
                          left: '-5rem',
                          width: '8rem',
                        }}
                      >
                        <li className="mv2">
                          <Link
                            className="no-underline underline-hover black"
                            to="/how-to-sotu"
                          >
                            How do I use SOTU?
                          </Link>
                        </li>
                        <li className="mv2">
                          <button
                            className="pa0 bg-transparent b--none cursor-pointer underline-hover"
                            onClick={this.handleSignOutClick}
                            type="submit"
                          >
                            Sign Out
                          </button>
                        </li>
                      </ul>
                    }
                  </div>
                }
              </div>
            </div>
          </header>
          <div className={`${wrapClasses}`}>
            { content || children }
          </div>
        </div>
        {footerJSX}
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/containers/App/index.jsx
 **/